var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlantsGroupIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 129.5,
    stroke: "#5056FD",
    strokeDasharray: "8 8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 105.5,
    r: 85.25,
    stroke: "#5056FD",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 64.5,
    r: 12.5,
    fill: "url(#paint0_radial_658_206)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 119,
    r: 19,
    fill: "url(#paint1_radial_658_206)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 243,
    r: 17,
    fill: "url(#paint2_radial_658_206)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9143 27.9069L58.5946 38.1004L47.0557 21.6185L53.6094 13.1875L63.9143 27.9069Z",
    fill: "#2D32B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3929 42.5995L33.3393 28.2392L42.0358 19.2644L53.6113 13.1964L47.0103 21.5365L58.5705 38.0489L43.3929 42.5995Z",
    fill: "url(#paint3_angular_658_206)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_658_206",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(233.769 59.2115) rotate(38.8534) scale(22.2249)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566108
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661829,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#1B1B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#2B2C2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_658_206",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.7692 110.962) rotate(38.8534) scale(33.7818)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566108
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661829,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#1B1B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#2B2C2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_658_206",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.8462 235.808) rotate(38.8534) scale(30.2258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566108,
    stopColor: "#3B3FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661829,
    stopColor: "#2D32B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#2C30B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#373EFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_658_206",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4839 17.048) rotate(154.102) scale(29.2968 31.293)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000797948,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantsGroupIc);
export default __webpack_public_path__ + "static/media/plantsGroup_ic.97c0363fcfc019d52b1e43bfd1e6c2ad.svg";
export { ForwardRef as ReactComponent };